/**
 * @Author: wuyang
 * @Date: 2024/1/23
 * @Description: ""
 */

import { Modal } from 'antd'
import {
	createElement,
	createRef,
	forwardRef,
	useImperativeHandle,
	useState
} from 'react'
import { PayModalComponent } from '@/business-component/pay-modal/PayModalComponent'

export interface IOpenPayModalProps {
	// 0 算力包， 1 升级套餐
	payType: 0 | 1
	packageType?: string
	refuelingBagId?: string

}

interface IPayModalProps { }
interface IPayModalRef {
	openPayModal: (params: IOpenPayModalProps) => void
}
const PayModal = forwardRef<IPayModalRef, IPayModalProps>((props, ref) => {
	const [isModalOpen, setIsModalOpen] = useState(false)

	const [payModalProps, setPayModalProps] = useState<IOpenPayModalProps>({
		payType: 0,
		packageType: '1',
		refuelingBagId: ''
	})

	useImperativeHandle(
		ref,
		() => ({
			openPayModal: (params) => {
				setPayModalProps(params)

				showModal()
			}
		}),
		[]
	)
	const showModal = () => {
		setIsModalOpen(true)
	}

	const handleCancel = () => {
		setIsModalOpen(false)
	}

	return (
		<Modal
			title=""
			open={isModalOpen}
			getContainer={() => document.body}
			// destroyOnClose={true}
			centered={true}
			width={'100vw'}
			style={{
				maxWidth: '100%',
				top: 0,
				padding: 0,
				margin: 0,
				height: '100vh',
				pointerEvents: 'all'
			}}
			modalRender={() => {
				return (
					<div className={'flex h-[100vh] w-[100%] justify-center items-center'}>
						<PayModalComponent {...payModalProps} closeModal={handleCancel} />
					</div>
				)
			}}
		></Modal>
	)
})

const createPayModalElement = () => {
	const ref = createRef<IPayModalRef>()
	return {
		component: createElement(PayModal, { ref }),
		ref
	}
}

export const { component: payModalElement, ref: payModalRef } =
	createPayModalElement()

export const openPayModal = (props: IOpenPayModalProps) => {
	if (!payModalRef.current) return
	payModalRef.current.openPayModal(props)
}
